<template>
  <section class="content">
    <div class="col-md-6 col-xs-12">
      <div class="box box-primary">
        <div class="box-header with-border no-shadow">
          <h3 class="box-title"><i class="fa fa-gears mr-5"></i>{{'configuration' | translate}}</h3>
        </div>
        <div class="clear"></div>
        <div class="box-body">
          <div class="box-group pt-10">
            <label for="erp_system_id">{{'erp' | translate}}:</label>
            <div class="form-group">
              <select
                data-vv-as="ERP ID"
                :class="{'form-control': true, 'form-control-danger': errors.has('erp_system_id') }"
                name="erp_system_id"
                v-model="activeErp"
                @change="changeConfigTable"
              >
                <template v-for="erp in erpSystems">
                  <option class="normal" :value="erp.id">{{erp.name | translate}}</option>
                </template>
              </select>
              <span v-show="errors.has('erp_system_id')" class="small text-danger">{{ errors.first('erp_system_id') }}</span>
            </div>
          </div>
          <hr>
          <template v-if="activeErp === 4 || activeErp === 5 || activeErp === 7">
            <div class="mb-10">
              <strong>{{activeErpName.toUpperCase()}} {{'erp_configuration' | translate}}</strong>
            </div>
            <template v-if="activeErp === 7">
              <div class="input-group pb-10">
                <span class="input-group-addon">{{'etos_customer_id' | translate}}</span>
                <input
                  v-validate="'required'"
                  data-vv-as="Host"
                  type="text"
                  class="form-control"
                  name="host"
                  v-model="config.etos_customer_id"
                >
              </div>
              <div class="input-group pb-10">
                <span class="input-group-addon">{{'return_branch' | translate}}</span>
                <input
                  v-validate="'required'"
                  data-vv-as="Host"
                  type="text"
                  class="form-control"
                  name="host"
                  v-model="config.return_branch"
                >
              </div>
            </template>
            <div class="input-group pb-10">
              <span class="input-group-addon">Host</span>
              <input
                v-validate="'required'"
                data-vv-as="Host"
                type="text"
                class="form-control"
                name="host"
                placeholder="Host"
                v-model="config.host"
              >
            </div>
            <div v-show="errors.has('server.host')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.host') }}</span>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{'user' | translate}}:</span>
              <input
                v-validate="'required'"
                data-vv-as="user"
                type="text"
                class="form-control"
                name="user"
                :placeholder="'user' | translate"
                v-model="config.username"
              >
            </div>
            <div v-show="errors.has('server.user')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.user') }}</span>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{'password' | translate}}:</span>
              <input
                v-validate="'required'"
                data-vv-as="Password"
                type="text"
                class="form-control"
                name="password"
                :placeholder="'password' | translate"
                v-model="config.password"
              >
            </div>
            <div v-show="errors.has('server.password')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.password') }}</span>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{'path' | translate}}</span>
              <input
                v-validate="'required'"
                data-vv-as="Path"
                class="form-control"
                name="path"
                :placeholder="'path' | translate"
                type="text"
                v-model="config.path"
              >
            </div>
            <div v-show="errors.has('server.path')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.path') }}</span>
            </div>
            <template v-if="activeErp === 5">
              <div class="input-group pb-10">
                <span class="input-group-addon">{{'return_branch' | translate}}:</span>
                <input
                  v-validate="'required'"
                  data-vv-as="return_branch"
                  type="text"
                  class="form-control"
                  name="return_branch"
                  :placeholder="'return_branch' | translate"
                  v-model="config.return_branch"
                >
              </div>
            </template>
            <template v-if="config.id > 0 && activeErp !== companyErp">
              <hr>
              <input type="checkbox" class="form-check-input" name="updateCompanyErp" v-model="updateCompanyErp"/>
              <span class="text text-danger text-bold">Ich will die Warenwirtschaft von {{companyErpName}} auf {{activeErpName}} umstellen und bin mir bewusst darüber, dass dies zu Fehlern führen kann</span>
              <hr>
            </template>
            <div class="input-group">
              <button @click="processConfiguration" class="btn btn-success btn-flat pull-right">
                <i class="fa fa-save mr-5 "></i>{{'submit_configuration' | translate}}
              </button>
            </div>
          </template>
          <template v-else-if="activeErp === 2">
            <div class="mb-10">
              <strong>{{activeErpName.toUpperCase()}} {{'erp_configuration' | translate}}</strong>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">Service URL</span>
              <input
                v-validate="'required'"
                data-vv-as="Service URL"
                type="text"
                class="form-control"
                name="service_url"
                placeholder="Service URL"
                v-model="config.service_url"
              >
            </div>
            <div v-show="errors.has('server.service_url')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.service_url') }}</span>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{'user' | translate}}:</span>
              <input
                v-validate="'required'"
                data-vv-as="Username"
                type="text"
                class="form-control"
                name="username"
                :placeholder="'user' | translate"
                v-model="config.username"
              >
            </div>
            <div v-show="errors.has('server.username')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.username') }}</span>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{'password' | translate}}:</span>
              <input
                v-validate="'required'"
                data-vv-as="Password"
                type="text"
                class="form-control"
                name="password"
                :placeholder="'password' | translate"
                v-model="config.password"
              >
            </div>
            <div v-show="errors.has('server.password')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.username') }}</span>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{'return_branch' | translate}}:</span>
              <input
                v-validate="'required'"
                data-vv-as="return_branch"
                type="text"
                class="form-control"
                name="return_branch"
                :placeholder="'return_branch' | translate"
                v-model="config.return_branch"
              >
            </div>
            <div v-show="errors.has('server.username')" class="input-group pb-10">
              <span class="small text-danger">{{ errors.first('server.username') }}</span>
            </div>
            <template v-if="activeErp !== companyErp && config.id > 0">
              <hr>
              <input
                type="checkbox"
                class="form-check-input"
                name="updateCompanyErp"
                v-model="updateCompanyErp"
              >
              <span class="text text-danger text-bold">Ich will die Warenwirtschaft von {{companyErpName}} auf {{activeErpName}} umstellen und bin mir bewusst darüber, dass dies zu Fehlern führen kann</span>
              <hr>
            </template>
            <div class="input-group">
              <button @click="processConfiguration" class="btn btn-success btn-flat pull-right">
                <i class="fa fa-save mr-5 "></i>{{'submit' | translate}}
              </button>
            </div>
          </template>
          <template  v-else-if="activeErp === 6 && activeErp !== companyErp">
            <input
              type="checkbox"
              class="form-check-input"
              name="updateCompanyErp"
              v-model="updateCompanyErp"
            >
            <span class="text text-danger text-bold">Ich will die Warenwirtschaft von {{companyErpName}} auf {{activeErpName}} umstellen und bin mir bewusst darüber, dass dies zu Fehlern führen kann</span>
            <hr>
            <div class="input-group">
              <button @click="processConfiguration" class="btn btn-success btn-flat pull-right">
                <i class="fa fa-save mr-5 "></i>{{'submit' | translate}}
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xs-12">
      <div class="box box-primary">
        <div class="box-header with-border no-shadow">
          <h3 class="box-title"><i class="fa fa-gears mr-5"></i>{{'erp_configuration_extension' | translate}}</h3>
        </div>
        <div class="clear"></div>
        <div class="box-body">
          <template v-if="config.id > 0 && (activeErp === 2 || activeErp === 4 || activeErp === 7)">
            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
                <template v-for="(extension, index) in config.extensions">
                  <li :class="[index === 0 ? 'active' : '']">
                    <a :href="`#tab_${index}`" data-toggle="tab" aria-expanded="false">
                      {{extension.sales_channel | translate}}
                    </a>
                  </li>
                </template>
                <li
                  :class="[config.extensions.length === 0 ? 'active' : '']"
                >
                  <a href="#create" data-toggle="tab" aria-expanded="false">
                    <i class="fa fa-plus mr-5"></i>{{'create_new_extension' | translate}}
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <template v-for="(extension, index) in config.extensions">
                  <div :id="`tab_${index}`" :class="['tab-pane', index === 0 ? 'active' : '']">
                    <div class="input-group pb-10" v-if="activeErp === 2">
                      <span class="input-group-addon">{{'erp_channel_name' | translate}}</span>
                      <input
                        v-validate="'required'"
                        data-vv-as="ERP Channel Name"
                        type="text"
                        class="form-control"
                        name="wws_channel_name"
                        v-model="extension.wws_channel_name"
                      >
                    </div>
                    <div class="input-group pb-10" v-if="activeErp === 3 || activeErp === 7">
                      <span class="input-group-addon">{{'selling_store_id' | translate}}</span>
                      <input
                        v-validate="'required'"
                        data-vv-as="Selling Store ID"
                        type="text" class="form-control"
                        name="selling_store_id"
                        v-model="extension.selling_store_id"
                      >
                    </div>
                    <template v-if="activeErp === 4">
                      <div class="input-group pb-10">
                        <span class="input-group-addon">{{'shipping_cost_id' | translate}}</span>
                        <input
                          v-validate="'required'"
                          data-vv-as="Shipping Cost ID"
                          type="text"
                          class="form-control"
                          name="shipping_cost_id"
                          v-model="extension.shipping_cost_id"
                        >
                      </div>
                      <div class="input-group pb-10">
                        <span class="input-group-addon">{{'payment_type_id' | translate}}</span>
                        <input
                          v-validate="'required'"
                          data-vv-as="Payment ID"
                          type="text"
                          class="form-control"
                          name="payment_id"
                          v-model="extension.payment_id"
                        >
                      </div>
                      <div class="input-group pb-10">
                        <span class="input-group-addon">{{'i_shop' | translate}}</span>
                        <input
                          v-validate="'required'"
                          data-vv-as="Ishop"
                          type="text"
                          class="form-control"
                          name="ishop" v-model="extension.ishop"
                        >
                      </div>
                      <template v-if="extension.sales_channel === 'merchant_order_amazon'">
                        <div class="input-group pb-10">
                          <span class="input-group-addon">
                            <span class="text-info">{{'prime' | translate | toUpper}}</span> {{'payment_type_id' | translate}}
                          </span>
                          <input
                            v-validate="'required'"
                            data-vv-as="Prime Payment ID"
                            type="text"
                            class="form-control"
                            name="prime_payment_id"
                            v-model="extension.prime_payment_id"
                          >
                        </div>
                        <div class="input-group pb-10">
                          <span class="input-group-addon">
                            <span class="text-info">{{'prime' | translate | toUpper}}</span> {{'shipping_cost_id' | translate}}
                          </span>
                          <input
                            v-validate="'required'"
                            data-vv-as="Prime Shipping Cost ID"
                            type="text" class="form-control"
                            name="prime_shipping_cost_id"
                            v-model="extension.prime_shipping_cost_id"
                          >
                        </div>
                      </template>
                    </template>
                    <div class="input-group">
                      <button @click="processExtension(extension)" class="btn btn-flat btn-primary pull-right">
                        <i class="fa fa-save mr-5"></i>{{'edit_extension' | translate}}
                      </button>
                    </div>
                  </div>
                </template>
                <div id="create" :class="['tab-pane', config.extensions.length === 0 ? 'active' : '']">
                  <div class="input-group pb-10">
                    <span class="input-group-addon">{{'sales_channel' | translate}}</span>
                    <select
                      data-vv-as="ERP ID"
                      :class="{'form-control': true, 'form-control-danger': errors.has('erp_system_id') }"
                      name="sales_channel_new_config"
                      v-model="sales_channel_new_config"
                    >
                      <template v-for="mp in mps">
                        <option class="normal" :value="mp.id">{{mp.name | translate}}</option>
                      </template>
                    </select>
                  </div>
                  <div class="input-group pb-10" v-if="activeErp === 2">
                    <span class="input-group-addon">{{'erp_channel_name' | translate}}</span>
                    <input
                      v-validate="'required'"
                      data-vv-as="ERP Channel Name"
                      type="text"
                      class="form-control"
                      name="wws_channel_name"
                      v-model="wws_channel_name"
                    >
                  </div>
                  <div class="input-group pb-10" v-if="activeErp === 3 || activeErp === 7">
                    <span class="input-group-addon">{{'selling_store_id' | translate}}</span>
                    <input
                      v-validate="'required'"
                      data-vv-as="Selling Store ID"
                      type="text"
                      class="form-control"
                      name="selling_store_id"
                      v-model="selling_store_id"
                    >
                  </div>
                  <template v-if="activeErp === 4">
                    <div class="input-group pb-10">
                      <span class="input-group-addon">{{'shipping_cost_id' | translate}}</span>
                      <input
                        v-validate="'required'"
                        data-vv-as="Shipping Cost ID"
                        type="text"
                        class="form-control"
                        name="shipping_cost_id"
                        v-model="shipping_cost_id"
                      >
                    </div>
                    <div class="input-group pb-10">
                      <span class="input-group-addon">{{'payment_type_id' | translate}}</span>
                      <input
                        v-validate="'required'"
                        data-vv-as="Payment ID"
                        type="text"
                        class="form-control"
                        name="payment_id"
                        v-model="payment_id"
                      >
                    </div>
                    <div class="input-group pb-10">
                      <span class="input-group-addon">{{'i_shop' | translate}}</span>
                      <input
                        v-validate="'required'"
                        data-vv-as="Ishop"
                        type="text"
                        class="form-control"
                        name="ishop"
                        v-model="ishop"
                      >
                    </div>
                    <template v-if="sales_channel_new_config === 14">
                      <div class="input-group pb-10">
                        <span class="input-group-addon">
                          <span class="text-info">{{'prime' | translate | toUpper}}</span> {{'payment_type_id' | translate}}
                        </span>
                        <input
                          data-vv-as="Prime Payment ID"
                          type="text"
                          class="form-control"
                          name="prime_payment_id"
                          v-model="prime_payment_id"
                        >
                      </div>
                      <div class="input-group pb-10">
                        <span class="input-group-addon">
                          <span class="text-info">{{'prime' | translate | toUpper}}</span> {{'shipping_cost_id' | translate}}
                        </span>
                        <input
                          data-vv-as="Prime Shipping Cost ID"
                          type="text"
                          class="form-control"
                          name="prime_shipping_cost_id"
                          v-model="prime_shipping_cost_id"
                        >
                      </div>
                    </template>
                  </template>
                  <div class="input-group">
                    <button @click="processExtension(0)" class="btn btn-success btn-flat pull-right">
                      <i class="fa fa-save mr-5 "></i>{{'submit_extension' | translate}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <span v-if="activeErp !== 6 && activeErp !== 5" class="text text-bold text-danger">
              {{'erp_extension_error' | translate}}
            </span>
            <span v-else>
              {{'erp_no_extension' | translate}}
            </span>
          </template>
        </div>
      </div>
    </div>
    </section>
</template>
<script>
export default {
  data () {
    return {
      type: 'barcode',
      company: {},
      alerts: [],
      configurations: {},
      active: 'true',
      placeholder: '',
      config: {},
      updateCompanyErp: false,
      activeErp: this.$store.getters.companyErpIdHelper,
      companyErp: this.$store.getters.companyErpIdHelper,
      activeErpName: this.$store.getters.companyErpNameHelper,
      companyErpName: this.$store.getters.companyErpNameHelper,
      erpSystems: [
        {id:2, name:'ipos'},
        {id:4, name:'his'},
        {id:5, name:'bits'},
        {id:7, name:'etos'},
        {id:6, name:'webservice'}
      ],
      mps: [
        {id:1, name:'schuhede'},
        {id:2, name:'schuhede-ebay'},
        {id:3, name:'schuhede-zalando'},
        {id:4, name:'schuhede-amazon'},
        {id:10, name:'schuhede-spartoo'},
        {id:12, name:'schuhede-mirapodo'},
        {id:14, name:'merchant_order_amazon'},
        {id:15, name:'merchant_order_ebay'},
        {id:16, name:'merchant_order_spartoo'},
        {id:18, name:'schuhede-tamaris'},
        {id:20, name:'schuhede-check24'},
        {id:27, name:'schuhede-legero'},
        {id:29, name:'schuhede-gaxsys'},
        {id:38, name:'schuhede-goertz'},
        {id:40, name:'schuhede-tamaris_at'},
        {id:42, name:'schuhede-marco_tozzi'},
        {id:44, name:'schuhede-sport2000'},
        {id:45, name:'merchant_order_gabor'},
        {id:46, name:'merchant_order_avendu'},
        {id:48, name:'schuhede-caprice'},
        {id:50, name:'schuhede-selfservice_schuhede'},
        {id:52, name:'schuhede-limango_de'},
        {id:54, name:'schuhede-kaufland_de'},
        {id:55, name:'merchant_order_atalanda'},
        {id:56, name:'merchant_order_bagmondo'},
        {id:58, name:'schuhede-ats_de'}
      ],
      ishop: '',
      shipping_cost_id: '',
      sales_channel_new_config: 1,
      payment_id: '',
      selling_store_id: '',
      wws_channel_name: '',
      prime_payment_id: '',
      prime_shipping_cost_id: '',
      erpConfig: {},
      configExtension: {},
    }
  },
  methods: {
    prepareErpPostData () {
      switch (this.activeErpName) {
        case 'etos':
          this.erpConfig = {
            company_id: this.$route.params.id,
            etos_customer_id: this.config.etos_customer_id,
            username: this.config.username,
            password: this.config.password,
            host: this.config.host,
            path: this.config.path,
            return_branch: this.config.return_branch
          }
          break
        case 'etosApollon':
          this.activeErpName = 'etos'
          this.erpConfig = {
            company_id: this.$route.params.id,
            etos_customer_id: this.config.etos_customer_id,
            username: this.config.username,
            password: this.config.password,
            host: this.config.host,
            path: this.config.path,
            return_branch: this.config.return_branch
          }
          break
        case 'his':
          this.erpConfig = {
            company_id: this.$route.params.id,
            username: this.config.username,
            password: this.config.password,
            host: this.config.host,
            path: this.config.path
          }
          break
        case 'ipos':
          this.erpConfig = {
            company_id: this.$route.params.id,
            username: this.config.username,
            password: this.config.password,
            service_url: this.config.service_url,
            return_branch: this.config.return_branch,
          }
          break
        case 'bits':
          this.erpConfig = {
            company_id: this.$route.params.id,
            username: this.config.username,
            password: this.config.password,
            host: this.config.host,
            path: this.config.path,
            return_branch: this.config.return_branch
          }
          break
      }
    },
    prepareConfigExtension () {
      switch (this.activeErpName) {
        case 'etos':
          this.configExtension = {
            configuration_id: this.config.id,
            sales_channel_id: this.sales_channel_new_config,
            selling_store_id: this.selling_store_id
          }
          break
        case 'etosApollon':
          this.activeErpName = 'etos'
          this.configExtension = {
            configuration_id: this.config.id,
            sales_channel_id: this.sales_channel_new_config,
            selling_store_id: this.selling_store_id
          }
          break
        case 'his':
          this.configExtension = {
            configuration_id: this.config.id,
            sales_channel_id: this.sales_channel_new_config,
            shipping_cost_id: this.shipping_cost_id,
            payment_id: this.payment_id,
            ishop: this.ishop,
            prime_payment_id: this.prime_payment_id,
            prime_shipping_cost_id: this.prime_shipping_cost_id
          }
          break
        case 'ipos':
          this.configExtension = {
            configuration_id: this.config.id,
            sales_channel_id: this.sales_channel_new_config,
            wws_channel_name: this.wws_channel_name
          }
          break
      }
    },
    processExtension (extension) {
      let alert
      if (extension.id > 0) {
        API.put(`accounting/companies/${this.$route.params.id}/erp/${this.activeErpName}/${this.config.id}/extension/${extension.id}`, extension)
          .then(response => {
            this.changeConfigTable()
            alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + error.response.data.message, icon: 'icon fa fa-ban', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
      } else {
        this.prepareConfigExtension()
        API.post(`accounting/companies/${this.$route.params.id}/erp/${this.activeErpName}/${this.config.id}/extension`, this.configExtension)
          .then(response => {
            this.changeConfigTable()
            this.ishop = ''
            this.shipping_cost_id = ''
            this.sales_channel_new_config = 1
            this.payment_id = ''
            this.selling_store_id = ''
            this.wws_channel_name = ''
            this.prime_shipping_cost_id = ''
            this.prime_payment_id = ''
            alert = {dismiss: 4, type: 'success', message: 'Creation Successful', icon: 'icon fa fa-check', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + error.response.data.message, icon: 'icon fa fa-ban', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
      }
    },
    processConfiguration () {
      let alert
      this.prepareErpPostData()
      if (this.config.id > 0) {
        API.put(`accounting/companies/${this.$route.params.id}/erp/${this.activeErpName}/${this.config.id}`, this.erpConfig)
          .then(response => {
            alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + error.response.data.message, icon: 'icon fa fa-ban', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
      } else {
        API.post(`accounting/companies/${this.$route.params.id}/erp/${this.activeErpName}`, this.erpConfig)
          .then(response => {
            this.config.id = response.data.id
            alert = {dismiss: 4, type: 'success', message: 'Creation Successful', icon: 'icon fa fa-check', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + error.response.data.message, icon: 'icon fa fa-ban', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
      }

      if (this.updateCompanyErp === true) {
        API.put(`accounting/companies/${this.$route.params.id}/erp/${this.activeErpName}`, )
          .then(response => {
            this.$router.push(`/accounting/companies/${this.$route.params.id}`)
          })
          .catch(error => {
            alert = {dismiss: 4, type: 'danger', message: `There was an error: ${error.response.data.message}`, icon: 'icon fa fa-ban', show: true}
            //this.alerts.push(alert)
            this.$store.commit('pushAlert', alert)
          })
      }
    },
    changeConfigTable () {
      let erp = this.erpSystems.find(x => x.id === this.activeErp)
      this.activeErpName = erp.name.toLowerCase()
      API.get(`accounting/companies/${this.$route.params.id}/erp/${this.activeErpName}`)
        .then(response => {
          this.config = response.data
        })
        .catch(error => {
          this.$emit('update', 'error')
        })
    },
  },
  mounted () {
    this.$nextTick(() => {
      API.get(`accounting/companies/${this.$route.params.id}`)
        .then(response => {
          this.company = response.data
        })
        .catch(error => {
          console.log(error.response)
        })
      API.get(`accounting/companies/${this.$route.params.id}/erp/${this.$store.getters.companyErpNameHelper}`)
        .then(response => {
          this.config = response.data
        })
        .catch(error => {
          if (error.response.status === 404) {
            switch (this.$store.getters.companyErpNameHelper) {
              case 'etos':
                this.config = {
                  id: '',
                  etos_customer_id: '',
                  user: '',
                  password: '',
                  host: '',
                  path: '',
                  return_branch: '',
                  extensions: []
                }
                break
              case 'bits':
                this.config = {
                  id: '',
                  username: '',
                  password: '',
                  host: '',
                  path: '',
                  return_branch: ''
                }
                break
              case 'his':
                this.config = {
                  id: '',
                  username: '',
                  password: '',
                  host: '',
                  path: '',
                  extensions: []
                }
                break
              case 'ipos':
                this.config = {
                  id: '',
                  username: '',
                  password: '',
                  service_url: '',
                  return_branch: '',
                  extensions: []
                }
              }
          }
        })
      })
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/AdvancedConfig.vue